import { render, staticRenderFns } from "./CarrierFormAdditional.vue?vue&type=template&id=0168cb5b&scoped=true&"
import script from "./CarrierFormAdditional.vue?vue&type=script&lang=ts&"
export * from "./CarrierFormAdditional.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierFormAdditional.vue?vue&type=style&index=0&id=0168cb5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168cb5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
